<script>
  import { getPublicClient, writeContract } from "@wagmi/core";

  import { chainExplorer, walletAddress } from "../stores.js";
  import { getABI, getBalance, getContractValue } from "../utils.js";

  export let chain;
  export let address;

  let loadingData = true;
  let max = 0;

  let recycling = false;
  let txHash;
  let feedback;

  $: $walletAddress, init();

  const init = async () => {
    if ($walletAddress) {
      const [ collection, tokenId ] = await Promise.all([
        getContractValue(chain, address, 'collection'),
        getContractValue(chain, address, 'tokenId')
      ]);
      max = await getBalance(chain, $walletAddress, collection, tokenId);
      loadingData = false;
    }
  }

  const recycle = async () => {
    recycling = true;
    try {
      const { hash } = await writeContract({
        chainId: chain, address: address, abi: await getABI(address, chain), functionName: 'recycle'
      });
      txHash = hash;
    } catch (err) {
      if (err.shortMessage === 'User rejected the request.') {
        dispatch('user-cancel');
        new CustomEvent('user-cancel');
      } else {
        console.log(err)
        dispatch('error', err);
        new CustomEvent('error', { detail: err });
      }
      recycling = false;
      return;
    }

    max += 1;

    dispatch('hashed', txHash);
    new CustomEvent('hashed', { detail: txHash });
    const receipt = await getPublicClient().waitForTransactionReceipt({ hash: txHash });
    dispatch('recycled', receipt)
    new CustomEvent('recycled', { detail: receipt });
    feedback = 'Recycled!';
    setTimeout(() => { feedback = undefined; }, 5000);
    txHash = undefined;
    recycling = false;
  }
</script>

{#if loadingData}
  Loading...
{:else if feedback}
  <span class={ $$props.class } class:lt-build={ true } class:feedback={ true }>{ feedback }</span>
{:else if txHash}
  <a href="{ $chainExplorer.url }/tx/{ txHash }" target="_blank">View tx</a>
{:else if max}
  <button class={ $$props.class } class:lt-build={ true } on:click={ recycle }>
    {#if recycling}
      <span class="loading loading-spinner"></span>
    {/if}
    Recycle
  </button>
{/if}